/**
 * External dependencies
 */

/**
 * Internal dependencies
 */
import {
  SET_PROJECT_INITIALIZE,
  SET_PROJECT_LIST,
  SET_PROJECT_INFO
} from '@naruto/bgdcms/src/reducers/cores/project/actions';
import { errorCatch } from '@naruto/bgdcms/src/reducers/_Capture/errorCapture';
import {
  Dispatch,
  ThunkAction,
  Models,
  MiddleWare,
  ProjectList,
  ProjectListCondition,
  ProjectListAPICondition,
  ProjectInfo,
  ProjectCreateData,
  ProjectUpdateData
} from './types';

/* Initial */
/**
 * 初始化管理 store 資料
 */
export const postProjectInitialize =
  (): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(SET_PROJECT_INITIALIZE());
  };

/**
 * 取得專案列表
 */
export const getProjectList =
  (condition: ProjectListCondition): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { api }): Promise<void> => {
    const result = await api.project.getProjectList<ProjectList, ProjectListAPICondition>(condition.api);
    if (!result.error && result.response) {
      dispatch(SET_PROJECT_LIST({ list: result.response, condition }));
    } else {
      const oldState = getState().project.projectList;
      if (oldState) {
        dispatch(
          SET_PROJECT_LIST({
            list: { ...oldState.content },
            condition: { ...oldState.condition }
          })
        );
      } else {
        dispatch(
          SET_PROJECT_LIST({
            list: {
              list: [],
              pager: {
                page: 1,
                page_size: 1,
                total_page: 1,
                total_count: 1
              }
            },
            condition: {
              api: {
                page: 1,
                page_size: 40,
                with_pager: false
              }
            }
          })
        );
      }
    }
    await dispatch(errorCatch(result.error, result.status));
  };
/**
 * 更新專案列表查詢條件
 */
export const postProjectListCondition =
  (condition: ProjectListCondition): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState): Promise<void> => {
    const oldState = getState().project.projectList;
    dispatch(SET_PROJECT_LIST({ list: { ...oldState.content }, condition }));
  };
/**
 * 取得專案資訊
 */
export const getProjectInfo =
  (projectID: string): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { api }): Promise<void> => {
    const result = await api.project.getProjectInfo<ProjectInfo>(projectID);
    if (!result.error && result.response) {
      dispatch(SET_PROJECT_INFO({ projectID, projectInfo: result.response }));
    } else {
      const oldState = getState().project.projectInfos[projectID];
      if (oldState) {
        dispatch(SET_PROJECT_INFO({ projectID, projectInfo: { ...oldState } }));
      } else {
        dispatch(
          SET_PROJECT_INFO({
            projectID,
            projectInfo: {
              project: {
                id: projectID,
                ctime: '',
                mtime: ''
              }
            }
          })
        );
      }
    }
    await dispatch(errorCatch(result.error, result.status));
  };
/**
 * 建立專案
 */
export const postProject =
  (
    projectData: ProjectCreateData,
    successCallback?: () => void,
    errorCallback?: () => void
  ): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { api }): Promise<void> => {
    const result = await api.project.postProject<ProjectInfo, ProjectCreateData>(projectData);
    if (!result.error && result.response) {
      if (successCallback) {
        successCallback();
      }
    }
    if (result.error && errorCallback) {
      errorCallback();
    }
    await dispatch(errorCatch(result.error, result.status));
  };
/**
 * 更新專案
 */
export const putProject =
  (
    projectID: string,
    projectData: ProjectUpdateData,
    successCallback?: () => void,
    errorCallback?: () => void
  ): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { api }): Promise<void> => {
    const result = await api.project.putProject<ProjectInfo, ProjectUpdateData>(projectID, projectData);
    if (!result.error && result.response) {
      if (successCallback) {
        successCallback();
      }
    }
    if (result.error && errorCallback) {
      errorCallback();
    }
    await dispatch(errorCatch(result.error, result.status));
  };
/**
 * 刪除專案
 */
export const deleteProject =
  (
    projectID: string,
    successCallback?: () => void,
    errorCallback?: () => void
  ): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { api }): Promise<void> => {
    const result = await api.project.deleteProject<ProjectInfo>(projectID);
    if (!result.error && result.response) {
      if (successCallback) {
        successCallback();
      }
    }
    if (result.error && errorCallback) {
      errorCallback();
    }
    await dispatch(errorCatch(result.error, result.status));
  };
